import { render } from "./detail-rekap_peserta.vue?vue&type=template&id=3b6dbff7"
import script from "./detail-rekap_peserta.vue?vue&type=script&lang=js"
export * from "./detail-rekap_peserta.vue?vue&type=script&lang=js"

import "./detail-rekap_peserta.vue?vue&type=style&index=0&id=3b6dbff7&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__